import Calendar from './index.vue';

Calendar.install = (Vue) => {
  Vue.component(Calendar.name, Calendar);
};

export default Calendar;
